import template from './procedure-template.html';
import controller from './procedure-template.controller';

let procedureTemplateComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default procedureTemplateComponent;
